import { useContext, useEffect } from 'react';
import { usePrevious } from '../../hooks/usePrevious';
import { HSAnalyticsContext } from '../context/HSAnalyticsContext';
export default function HSPageViewTracker({
  pathname
}) {
  const prevPathname = usePrevious(pathname);
  const {
    initialPageLoad,
    setInitialPageLoad
  } = useContext(HSAnalyticsContext);
  useEffect(() => {
    if (!initialPageLoad && pathname !== prevPathname) {
      const _hsq = window._hsq = window._hsq || [];

      _hsq.push(['setPath', pathname]);

      _hsq.push(['trackPageView']);
    }

    setInitialPageLoad(false);
  }, [initialPageLoad, pathname, prevPathname, setInitialPageLoad]);
  return null;
}